/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function EndUser(props) {
	
	const { t } = useTranslation();

	return (
		<BasicCrudScreenType
			id={"EndUser"}
			headerTitle={t("term.EndUser")}
			table={"EndUser"}
			view={"VwEndUser"}
			buttonsInFrontOfSearch
		/>
	);
}

export default EndUser;
